
/**
 * @nullable
 */
export type NotificationItemData = {[key: string]: unknown} | null;
